import { inject, Injectable } from '@angular/core';

import { DialogWidth } from '@core/user-interface-legacy';
import { injectSlotsLimitDialogOpenerContract } from '@recruitee/billing-contracts';
import { BulkActionType } from '@recruitee/bulk-actions-legacy';
import { SubscriptionService } from '@recruitee/company-logic';

@Injectable()
export class ViewsOffersBulkActionsValidatorService {
  private readonly slotsLimitDialogOpener = injectSlotsLimitDialogOpenerContract();
  private readonly subscription = inject(SubscriptionService);

  public isActionPermitted(id: BulkActionType, ids: number[]) {
    switch (id) {
      case BulkActionType.RetrieveArchived:
        if (this.subscription.wouldCountExceedLimit(ids.length)) {
          this.openSlotsLimitDialog(ids.length);
          return false;
        }
        return true;
      default:
        return true;
    }
  }

  private openSlotsLimitDialog(offersCount: number): void {
    this.slotsLimitDialogOpener.open(
      { width: DialogWidth.Small },
      {
        isTrial: this.subscription.isTrial(),
        triggeredFromBulkCount: offersCount,
      },
    );
  }
}
